/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_SanitizationInputs */

const en_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanitization`)
};

const ar_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التنقية`)
};

const bn_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্যানিটাইজেশন`)
};

const de_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desinfektion`)
};

const es_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanitización`)
};

const fr_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désinfection`)
};

const pt_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sanitização`)
};

const zh_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消毒`)
};

const tr_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterilizasyon`)
};

const ru_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Санитарная обработка`)
};

const pl_svchip_sanitization = /** @type {(inputs: Svchip_SanitizationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezynfekcja`)
};

/**
* | output |
* | --- |
* | "Sanitization" |
*
* @param {Svchip_SanitizationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_sanitization = /** @type {((inputs?: Svchip_SanitizationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_SanitizationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_sanitization(inputs)
	if (locale === "bn") return bn_svchip_sanitization(inputs)
	if (locale === "de") return de_svchip_sanitization(inputs)
	if (locale === "es") return es_svchip_sanitization(inputs)
	if (locale === "fr") return fr_svchip_sanitization(inputs)
	if (locale === "pt") return pt_svchip_sanitization(inputs)
	if (locale === "zh") return zh_svchip_sanitization(inputs)
	if (locale === "tr") return tr_svchip_sanitization(inputs)
	if (locale === "ru") return ru_svchip_sanitization(inputs)
	if (locale === "pl") return pl_svchip_sanitization(inputs)
	return en_svchip_sanitization(inputs)
});